import { QuestionTitle } from "components/atoms"
import { PrimaryButton } from "components/molecules"
import { Screen } from "config/types"
import { useEffect } from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import { twMerge } from "tailwind-merge"
import { ReactComponent as ReviewsBorder } from "assets/images/reviews-border.svg"

const FEATURED_TEXT_FONT = 'bold 1em "Quirk Bold"'

const preloadFeaturedTextFont = () =>
  document.fonts?.load(FEATURED_TEXT_FONT).catch(() => {})

type ReviewStubProps = {
  screen: Screen
  onClick: () => void
}

export function ReviewStub(props: ReviewStubProps) {
  const {
    screen: {
      image,
      imageText,
      featuredImage,
      featuredImageTitle,
      featuredText,
      values,
      title,
    },
    onClick,
  } = props

  useEffect(() => {
    if (featuredText) {
      preloadFeaturedTextFont()
    }
  }, [featuredText])

  return (
    <div className="flex flex-col h-full">
      {title && (
        <div>
          <QuestionTitle id={title} />
        </div>
      )}
      <div className={twMerge(!title && "grow")}>
        {image && !imageText && (
          <img
            src={image}
            className="w-full m-auto mt-8 mb-8 height-650:max-w-[80%] height-530:my-2"
          />
        )}
        {image && imageText && (
          <div className="relative w-full m-auto mt-8 mb-8 height-650:max-w-[80%] height-530:my-2 text-[15px] leading-[21px] [container-type:inline-size]">
            <ReviewsBorder className="absolute inset-0 w-full h-full text-white" />
            <div className="relative pt-[3.7%] pb-[8.68%]">
              <img src={image} className="block w-[35.51%] mx-auto" />
              <div className="mt-[3.11%] ml-[9.3%] mr-[8.8%] text-left text-[length:4.8cqw] leading-[5.9cqw]">
                <FormattedMessage id={imageText} />
              </div>
            </div>
          </div>
        )}
        {featuredImage && !featuredImageTitle && (
          <img
            src={featuredImage}
            className="w-full m-auto mt-8 mb-8 height-650:max-w-[80%] height-530:my-4"
          />
        )}
        {featuredImage && featuredImageTitle && (
          <div className="w-full m-auto mt-8 mb-8 height-650:max-w-[80%] height-530:my-4 text-[20px] [container-type:inline-size]">
            <div className="h-[12cqw] pt-[1.66cqw] text-center font-sans-bold uppercase text-[length:5.4cqw] leading-none tracking-[0.1cqw]">
              <FormattedMessage id={featuredImageTitle} />
            </div>
            <img
              src={featuredImage}
              className="block w-[67.73%] mx-auto mb-[0.5cqw]"
            />
          </div>
        )}
        {featuredText && (
          <div className="mt-8 mb-8 font-quirk uppercase text-center text-[31px] leading-[34px] tracking-[1px] height-650:text-[26px] height-650:leading-[29px] height-530:my-4">
            <FormattedMessage
              id={featuredText}
              values={{
                count: (
                  <span className="text-pink text-[37px] height-650:text-[31px]">
                    <FormattedNumber value={values?.users ?? 0} />
                  </span>
                ),
              }}
            />
          </div>
        )}
      </div>
      <div className="w-full text-center pt-3 mb-6">
        <PrimaryButton onClick={onClick}>
          <FormattedMessage id="continue" />
        </PrimaryButton>
      </div>
    </div>
  )
}
